import React from 'react';
import request from 'arcdynamic-request';
import { PROPERTIES } from '../../consts/tables';
import { geocodeAndSave } from '../../utils/geocode';

function fetchNext(skipped) {
	return request(arc.path.api, {
		service: 'arcimedes',
		action: 'open.datasource.table.Data.getData',
		params: ['code', PROPERTIES, {
			column: [
				'ARCIMEDES_ROW_ID',
				'CITY',
				'STATE',
				'ADDRESS',
				'ZIP',
				'LATITUDE',
				'LONGITUDE',
			],
			limit: { count: 1, offset: skipped },
			filterType: 'and',
			filter: [
				{ text: '', code: 'LATITUDE', type: 'null' },
				{ text: '', code: 'ADDRESS', type: 'notNull' },
				{ text: '', code: 'CITY', type: 'notNull' },
				{ text: '', code: 'STATE', type: 'notNull' },
			],
		}],
	});
}

export default class GeoCoder extends React.Component {
	constructor(props) {
		super(props);
		this.state = { isComplete: false, error: null };
		this._crawl = this._crawl.bind(this);
		// Rows left without a point stay first in line; stepping past them keeps the crawl from asking about one forever.
		this.skipped = 0;
	}

	_crawl() {
		fetchNext(this.skipped).then(res => {
			if (res && res.success && Array.isArray(res.data)) {
				if (res.data[0]) {
					geocodeAndSave(res.data[0]).catch((error) => {
						console.error('Could not place', res.data[0], error);
						return null;
					}).then(geo => {
						if (!geo) {
							this.skipped++;
							console.error('Could not geocode', res.data[0]);
						}
						setTimeout(() => this._crawl(), 1000);
					});
				} else {
					this.setState({ isComplete: true, error: null });
				}
			} else {
				this.setState({ error: res.message || 'Unidentified Error' });
			}
		});
	}

	componentDidMount() {
		this._crawl();
	}

	render() {
		return (
			<div className='GeoCoder'>
				{this.state.isComplete
					? <div>Finished!</div>
					: <div>Geocoding addresses, this may take a few minutes</div>
				}
			</div>
		);
	}
}
